import { render, staticRenderFns } from "./EWSendMoney.vue?vue&type=template&id=6212089a&"
import script from "./EWSendMoney.vue?vue&type=script&lang=js&"
export * from "./EWSendMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports